export default "__VITE_ASSET__B05AnWM0__"